import { BucketId, FileReferenceId } from '@kaizenplatform/belfast-entity';

import HttpClient from '../../adapter/HttpClient';

class DownloadApi {
  private readonly httpClient: HttpClient;

  constructor({ httpClient }: { httpClient: HttpClient }) {
    this.httpClient = httpClient;
  }

  public download = async ({
    buckets = [],
    files = [],
    projects = [],
    creatives = [],
    bucketIdForFiles,
    handler,
  }: {
    buckets: ReadonlyArray<BucketId>;
    files: ReadonlyArray<FileReferenceId>;
    projects: ReadonlyArray<string>;
    creatives?: ReadonlyArray<string>;
    bucketIdForFiles?: BucketId;
    handler?: (data: any) => void;
  }): Promise<void> => {
    const params: { [key: string]: ReadonlyArray<string> | string } = {};

    params['user_type'] = 'Director';
    if (buckets.length > 0) {
      params['buckets'] = buckets;
    }
    if (files.length > 0) {
      if (bucketIdForFiles == null) {
        throw new Error('Require bucketId when use files');
      }

      params['files'] = files;
      params['bucket_id_for_files'] = bucketIdForFiles;
    }
    if (projects.length > 0) {
      params['projects'] = projects;
    }
    if (creatives.length > 0) {
      params['creatives'] = creatives;
    }

    await this.httpClient.post('/download', params).then(handler);
  };

  public get = async ({
    downloadKey,
    handler,
  }: {
    downloadKey: string;
    handler?: (response: any) => void;
  }): Promise<void> => {
    await this.httpClient.get('/download/' + downloadKey + '/').then(handler);
  };

  public downloadFile = async ({ downloadKey, baseUrl }: { downloadKey: string; baseUrl: string }) => {
    const endpoint = baseUrl + '/download/' + downloadKey + '/file/';
    window.location.href = endpoint;
  };
}

export default DownloadApi;
